import { useEffect, useRef, useState } from 'react';
import { CheckboxField, SearchField, SelectField } from '@wk/components-react16';
import HttpService from "../../config/http.service";
import { API_URL } from "../../config/constants";
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Toast } from '../../services';

const SEARCH_FIELD_OPTIONS = [
    { value: 'name', label: 'Prompt Name' },
    { value: 'promptType', label: 'Prompt Type' },
    { value: 'createdBy', label: 'Created By' },
    { value: 'taxonomy', label: 'Taxonomy' },
    { value: 'id', label: 'Prompt Id' },
    { value: 'text', label: 'Prompt Text' },
];

const PromptSearch = ({ data }: any) => {
    const { getPrompts, facets, searchText = '', setSearchText, promptPayload, setPromptPayload, pagination } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const treeRef = useRef<HTMLDivElement>(null);
    const [results, setResults] = useState<any>({});
    const [checkedItems, setCheckedItems] = useState<Record<string, Record<string, boolean>>>({});
    const [isShowCatTree, setIsShowCatTree] = useState(false);
    const searchField = promptPayload.searchField || 'name';

    const handleSearchFieldChange = (value: string) => {
        setResults({});
        setCheckedItems({});
        setIsShowCatTree(false);
        setPromptPayload({ ...promptPayload, searchField: value });
    }

    const handleSearch = async (searchText: string) => {
        if (searchField !== 'taxonomy') {
            setResults({});
            return;
        }
        setIsShowCatTree(true);
        setCheckedItems({});
        if (searchText.length > 0) {
            if (authProject && authProject.id) {
                HttpService.postRequest(`${API_URL.POST_TAXONOMY_SEARCH}`, { query: searchText,projectId : authProject.id }).then(
                    (res: any) => {
                        setResults(res);
                    },
                    (err: any) => {
                        Toast(err.message, "error")
                    },
                )
            }
        } else {
            setResults({});
        }
    }

    const getCheckedIds = (checkedItems: any) => {
        let checkedIds: any = [];
        Object.values(checkedItems).forEach((category: any) => {
            Object.keys(category).forEach((id: any) => {
                if (category[id]) {
                    checkedIds.push(parseInt(id));
                }
            });
        });
        return checkedIds;
    };

    const handlePromptSearch = (searchText: string) => {
        promptPayload.filterText = searchText;
        setPromptPayload({ ...promptPayload });
        //setSearchText('');
        setCheckedItems({});
        setIsShowCatTree(false);
        getPrompts(1, pagination.pageSize);
    }

    const handleApplyCatId = () => {
        const checkedIds = getCheckedIds(checkedItems);
        promptPayload.catIds = checkedIds;
        setPromptPayload({ ...promptPayload });
        setSearchText('');
        promptPayload.filterText = '';
        getPrompts(1, pagination.pageSize);
        setIsShowCatTree(false);
    }

    const handleClearCatId = () => {
        setPromptPayload({ ...promptPayload, catIds: [] });
        setSearchText('');
        setResults({});
        setCheckedItems({});
        getPrompts(1, pagination.pageSize);
        setIsShowCatTree(false);
    }

    const handleCheckboxChange = (category: string, id: string) => {
        setCheckedItems((prevState: Record<string, Record<string, boolean>>) => ({
            ...prevState,
            [category]: {
                ...prevState[category],
                [id]: !prevState[category]?.[id]
            }
        }));
    };

    useEffect(() => {
        const debounce = setTimeout(() => {
            handleSearch(searchText);
        }, 500);
        return () => clearTimeout(debounce);
    }, [searchText]);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (treeRef.current && !treeRef.current.contains(event.target)) {
                setIsShowCatTree(false);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            {Object.keys(results).length > 0 && <div className="custom-overlay"></div>}
            <div className="search-block d-flex" id="search-tree" ref={treeRef}>
                <div className="mr-5" style={{ minWidth: '130px' }}>
                    <SelectField size="small" label="" labelFor="search-field-select">
                        <select
                            id="search-field-select"
                            value={searchField}
                            onChange={(event: any) => handleSearchFieldChange(event.target.value)}
                        >
                            {SEARCH_FIELD_OPTIONS.map((option) => (
                                <option value={option.value} key={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </SelectField>
                </div>
                <div className="flex1">
                <SearchField size="small" label="" labelFor="search-id-1-1"
                    onSearch={() => handlePromptSearch(searchText)}>
                    <input
                        type="search"
                        id="search-id-1-1"
                        name="searchPrompt"
                        value={searchText}
                        placeholder={`Search by ${SEARCH_FIELD_OPTIONS.find((option) => option.value === searchField)?.label || 'Prompt Name'}`}
                        onChange={(event: any) => setSearchText(event.target.value)}
                        onKeyDown={(event: any) => {
                            if (event.key === 'Enter') {
                                handlePromptSearch(event.target.value);
                            }
                        }}
                    />
                </SearchField>
                </div>
                {Object.keys(results).length > 0 && isShowCatTree && <div className="ac-item-container">
                    <div className='content-inner' style={{ maxHeight: 'calc(100vh - 274px)' }}>
                        {Object.keys(results).map(category => (
                            <div key={category}>
                                <div className="result-title"><strong>{category}</strong></div>
                                <ul>
                                    {results[category].map((item: any) => (
                                        <li key={item.id} className="ac-item" onClick={() => handleCheckboxChange(category, item.id)}>
                                            <div className="left-block">

                                            </div>
                                            <div className="right-block">
                                                <p className="search-breadcrumbs">{item?.parentNames?.join(' > ')}</p>
                                                <p className="text custom-fs-field">
                                                    <CheckboxField label={item.name}>
                                                        <input
                                                            name="tag"
                                                            type="checkbox"
                                                            checked={checkedItems[category]?.[item.id] || false}
                                                            onChange={() => handleCheckboxChange(category, item.id)} readOnly
                                                        />
                                                    </CheckboxField>
                                                </p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    <div className="bg-light text-right pt-5 pr-15 pb-5">
                        <button type="button" className="btn btn-sm btn-text-primary" onClick={() => handleClearCatId()}>Clear
                        </button>
                        <button type="button" className="ml-10 btn btn-sm btn-outline-primary" onClick={handleApplyCatId}>Apply Filter
                        </button>
                    </div>
                </div>}
            </div>
        </>
    )
}


export default PromptSearch;
